<template>
  <div class="checkTimePage">
    <header class="header">
      <Form>
        <FormItem style="text-align: right;" class="datePickerFormItem">
          <Icon type="left" @click="getLastDayTime" style="margin-right:10px;font-size:16px"/>
          <DatePicker :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="willDate" @change="getCheckTimeLists"></DatePicker>
          <Icon type="right" @click="getNextDayTime" style="margin-left:10px;font-size:16px"/>
        </FormItem>
      </Form>
    </header>
    <Skeleton v-show="showLoad" :paragraph="{rows: 11}" active></Skeleton>
    <article v-show="!showLoad" class="content" ref="content">
      <h3>{{todayDate}}</h3>
      <table border="1" class="timeTable">
        <tr v-for="(val, index) in nowCheckTimeList" :key="index">
          <td>{{zeroPadding(val.appointmentTime)}}</td>
          <Button disabled class="timeMS notAppointment" v-if="!val.isAppointment && !val.equivalentCount && isNot(todayDate, val.appointmentTime)">无预约</Button>
          <Button :class="isNot(todayDate, val.appointmentTime) ? 'timeMS' : 'notAppointment'" v-else-if="val.isAppointment && val.equivalentCount >= 0" :disabled="isNot(todayDate, val.appointmentTime)" @click="getCheckDate(val)">{{val.equivalentCount}}</Button>
          <Button class="appointment" v-else-if="!val.isAppointment" @click="getCheckDate(val)">预约</Button>
        </tr>
      </table>
      <h3>{{nextDate}}</h3>
      <table border="1" class="timeTable">
        <tr v-for="(val, index) in nextCheckTimeList" :key="index">
          <td>{{zeroPadding(val.appointmentTime)}}</td>
          <Button disabled class="timeMS notAppointment" v-if="!val.isAppointment && !val.equivalentCount && isNot(nextDate, val.appointmentTime)">无预约</Button>
          <Button :class="isNot(nextDate, val.appointmentTime) ? 'timeMS' : 'notAppointment'" v-else-if="val.isAppointment && val.equivalentCount >= 0" :disabled="isNot(nextDate, val.appointmentTime)" @click="getCheckDate(val)">{{val.equivalentCount}}</Button>
          <Button class="appointment" v-else-if="!val.isAppointment" @click="getCheckDate(val)">预约</Button>
        </tr>
      </table>
    </article>
    <footer class="footer">
      <div class="btnWrap">
        <Button size="large" @click="cancel">取消</Button>
        <Button size="large" type="primary" @click="sureCheck">确定</Button>
      </div>
    </footer>
  </div>
</template>

<script>
import { isDateOut, zeroPadding, getReservationDate } from '../../libs/utils'
import { getCheckTimeList } from '../../api/check'
import { Form, DatePicker, Button, Skeleton, Modal, Icon, } from 'ant-design-vue'
import moment from 'moment'
export default {
  components: {
    Form,
    FormItem: Form.Item,
    DatePicker,
    Button,
    Skeleton,
    Icon,
  },
  data () {
    return {
      todayDate: '',
      nextDate: '',
      nowCheckTimeList: [],
      nextCheckTimeList: [],
      year: '',
      time: '',
      willDate: getReservationDate(),
      showLoad: false,
      imageCenter: null,
      deviceId: null
    }
  },
  methods: {
    async getCheckData (imageId, deviceId) {
      this.imageCenter = imageId
      this.deviceId = deviceId
      await this.getCheckTimeLists()
    },
    async getCheckTimeLists () {
      this.scrollTop()
      this.showLoad = true
      let params = {
        medicalImageCenterId: this.imageCenter,
        medicalImageCenterDeviceId: this.deviceId,
        // queueUpDate: this.willDate.format('YYYY-MM-DD') + ' 00:00:00',
        isShowScheduled: true
      }
      if (this.willDate) params.queueUpDate = this.willDate.format('YYYY-MM-DD') + ' 00:00:00'
      let data = await getCheckTimeList(params)
      if (data) {
        this.todayDate = data.nowAppointTimeList.date
        this.nextDate = data.nextAppointTimeList.date
        this.nowCheckTimeList = data.nowAppointTimeList.list
        this.nextCheckTimeList = data.nextAppointTimeList.list
        this.showLoad = false
      }
    },
    isNot (date, time) {
      let firstTime = date.slice(0, 10)
      let lastTime = this.zeroPadding(time)
      let fullTime = `${firstTime} ${lastTime}`
      return isDateOut(fullTime)
    },
    getCheckDate (params) {
      this.year = params.appointmentDatetime.slice(0, 10)
      this.time = params.appointmentTime
    },
    cancel () {
      this.$emit('closeCheckModal')
    },
    sureCheck () {
      if (!this.year) return Modal.error({ title: '请选择预约时间' })
      this.$emit('getCheckDate', this.year, this.time)
      this.cancel()
    },
    zeroPadding (num) {
      return zeroPadding(num)
    },
    scrollTop () {
      this.$nextTick(() => {
        this.$refs.content.scrollTop = 0
      })
    },
    async getLastDayTime () {
      this.willDate = moment(this.willDate).add(-1, 'd')
      await this.getCheckTimeLists()
    },
    async getNextDayTime () {
      this.willDate = moment(this.willDate).add(1, 'd')
      await this.getCheckTimeLists()
    },
  },
}
</script>

<style lang="less">
@import url('../../style/index.less');
.checkTimePage{
  .content{
    height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
    h3{
      text-align: center;
      padding-bottom: 10px;
    }
    .timeTable{
      width: 100%;
      margin: 0 auto 10px 0;
      border-spacing: 0;
      border-color: #d9d9d9;
      border-radius: 20px;
      tr{
        width: 25%;
        display: inline-block;
        margin: 0;
        td{
          display: inline-block;
          width: 50%;
          height: 40px;
          text-align: center;
          line-height: 40px;
          font-weight: bold;
          border: 1px solid transparent;
          border-color: #d9d9d9;
        }
        button{
          display: inline-block;
          width: 50%;
          height: 40px;
          text-align: center;
          line-height: 40px;
          font-weight: bold;
          border-color: #d9d9d9;
          background-color: @baseColor;
        }
        .appointment{
          color: @primaryColor;
        }
        .notAppointment{
          color: @primaryColor;
        }
        .timeMS{
          background-color: rgba(0, 0, 0, 0.1);
          color: #000;
        }
        .ant-btn:focus, .ant-btn:hover{
          background-color: @primaryColor;
          color: @baseColor;
        }
      }
    }
  }
  .footer{
    .modalFooter();
    .btnWrap{
      margin-top: 0;
    }
  }
}
@media all and (max-width: 767px) {
  .checkTimeModal{
    top:50px;
    .ant-modal-body{
      height: 530px !important;
      padding: 10px 8px;
    }
    .checkTimePage{
      position: relative;
      height: 504px;
      .content{
        margin-top: 10px;
        min-width: 300px;
        max-width: 400px;
        .timeTable{
          tr{
            td{
              font-size: 10px;
            }
            .appointment{
              padding: 0 !important;
              font-size: 10px !important;
            }
            .notAppointment{
              padding: 0 !important;
              font-size: 10px !important;
            }
            .timeMS{
              padding: 0 !important;
              font-size: 10px !important;
            }
            .ant-btn{
              padding: 0 !important;
              font-size: 10px !important;
            }
          }
        }
      }
      .footer{
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 10px;
        margin: 0;
        div{
          border:none;
        }
      }
    }
    .datePickerFormItem{
      margin-bottom: 8px;
    }
  }
}
</style>
